import Keycloak from './keycloak.js';
/**
 * KeycloakのCookie監視をしてログアウトしたことを通知する
 * 受信メッセージ(呼び出し元から受け取る通知)
 *   login: Keycloakログインを行う
 * 送信メッセージ(呼び出し元への通知)
 *   - フォーマット: {action: "変更内容", 送信データ}
 *   - action
 *     * ready: Keycloak JavascriptAdapterが準備できたことを通知
 *       ログイン済みであれば送信データにidTokenとrefreshTokenが入る
 *       未ログインであれば送信データは空
 *     * logout: Keycloakログアウトしたことを通知
 */
const keycloak = new Keycloak({
    url: "https://accounts.atlas.jp",
    realm: "atlas-auth-production",
    clientId: "atlas-cli-public-production"
});

// 大元のWindowからの呼び出し
window.addEventListener("message", function(event) {
    if (event.origin != "https://accounts.atlas.jp") {
    if (navigator.cookieEnabled && event.data === "login") {
        keycloak.login({prompt: "none", scope: "offline_access"});
    } else if (!navigator.cookieEnabled) {
        // Cookie無効時は常に未ログインとする
        parent.postMessage({action: "ready"}, "*");
    }
    }
});

window.addEventListener("load", function() {
    if (navigator.cookieEnabled) {
    keycloak.onAuthLogout = function() {
        //ログアウトしたことを通知
        parent.postMessage({action: "logout"}, "*");
    };
    keycloak.onReady = function() {
        //Keycloak JavascriptAdapterが準備できたことを通知
        if (keycloak.idToken && keycloak.refreshToken) {
        parent.postMessage(
            {
            action: "ready",
            data: {
                idToken: keycloak.idToken,
                refreshToken: keycloak.refreshToken,
            },
            },
            "*"
        );
        } else {
        parent.postMessage({action: "ready"}, "*");
        }
    };
    keycloak.init({
        checkLoginIframeInterval: 5,
        enableLogging: true,
        onLoad: "check-sso",
        pkceMethod: "S256",
        silentCheckSsoRedirectUri:
            window.origin + "/html/static/silent-check-sso.html",
        }).then((authenticated) => {
        // サードパーティCookieがブロックされる場合keycloak.silentCheckSsoRedirectUriはfalseになる
        // safari等でsilent-check-ssoが無効になった場合は一定時間でトークンリフレッシュを行い
        // リフレッシュができない(Keycloakログアウト)した場合は元の画面にログアウトしたことを通知する
        if (authenticated && !keycloak.silentCheckSsoRedirectUri) {
            setInterval(() => {
            // updateTokenの引数を-1にすると強制的にリフレッシュ
            // これを10秒ごとに行うことで本来のSLOが使えないブラウザでもSLOをできるようにする
            keycloak.updateToken(-1).catch(function() {
                // 当該catchはトークン更新に失敗した場合に呼び出されるが、通信エラーの場合も呼び出される
                // http statusが400の場合にのみ(つまり、トークンが無効な場合にのみ)、Keycloak-jsは
                // keycloak.authenticatedの状態を更新する
                if (keycloak.authenticated) {
                // トークン更新に失敗したが、ログアウトとして処理しない
                return;
                }
                parent.postMessage({action: "logout"}, "*");
            });
            }, 10000);
        }
        })
        .catch(function() {
        parent.postMessage({action: "ready"}, "*");
        });
    } else {
    // ブラウザでCookie無効にされた等で初期化できない場合は未ログインとして返す
    parent.postMessage({action: "ready"}, "*");
    }
});